module.exports = __webpack_public_path__ + "static/media/factory_robot_arm.78be4d1c.glb";